import(/* webpackMode: "eager" */ "/app/frontend/src/app/dashboard/layout.tsx");
